import curd from '../curd'

const BASE_PATH = '/audit/rule/category'

export default curd(BASE_PATH, {
  getBySiteDeviceId: siteDeviceId => ({
    url: `/audit/manual/rule/${siteDeviceId}`,
    method: 'GET'
  })
})



// WEBPACK FOOTER //
// ./src/apis/modules/AuditRuleCategory.js